// extracted by mini-css-extract-plugin
module.exports = {"ArticleMedia":"ArticleMedia_ArticleMedia__PcCd9","ArticleMedia_caption":"ArticleMedia_ArticleMedia_caption__Hj6FH"};